import ApiService from './api'
import {TokenService} from './token'
import qs from 'qs';

class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.errorCode = errorCode
    }
}

const UserService = {
    getToken: async function () {
        const data = {
            grant_type: 'client_credentials',
            client_id: process.env.VUE_APP_CLIENT_ID,
            client_secret: process.env.VUE_APP_CLIENT_SECRET,
        };

        try {
            const response = await ApiService.post(process.env.VUE_APP_ROOT_API_AUTH, qs.stringify(data));
            if (response.data.access_token) {
                TokenService.saveToken(response.data.access_token);
                ApiService.setHeader();
                ApiService.mount401Interceptor();
                return response.data.access_token
            } else {
                throw {
                    response: {
                        status: 'invalid credentials',
                        data: {
                            detail: 'Please check if the provided client-credentials are correct.'
                        }
                    }
                };
            }
        } catch (error) {
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }

    },

    sendForm: async function (data){
        try {
            const response = await ApiService.post(`${process.env.VUE_APP_ROOT_API_ENV}/sendmail/sendEmailIivaara`, qs.stringify(data));
            console.log(response);
            if (response.status) {
                console.log('-- send form ok --');
                return response.data;
            } else {
                return false;
            }
        } catch (error) {
            console.warn('!! send form error ', error);
            return false;
        }
    },
};

export default UserService;

export {UserService, AuthenticationError};